<template>
  <div>
    <v-layout>
      <v-flex>
        <h4>
          {{ $t('payment_method') }}
          <i
            v-if="bankVerifyData.status && bankVerifyData.status === 'verified'"
            v-tooltip.top="$t('Verified by Meta')"
            class="fas fa-check-circle green--text mr-3"
            style="font-size: 20px;"
          ></i>
        </h4>
      </v-flex>
      <v-flex>
        <div class="text-xs-right">
          <v-btn
            v-if="index !== 0 || isMetaVerifySlip"
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="deleteDataBankVerify(bankVerifyData)"
          >
            <i class="fa fa-trash middle"></i>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <v-radio-group
      v-if="!isMetaVerifySlip"
      v-model="bankVerifyData.typeAccount"
      class="pa-1 mt-1 mb-1"
      row
    >
      <v-radio
        :label="$t('Transfer')"
        :value="{ value: 'transfer', label: 'Transfer' }"
        color="primary"
        @change="selectAllBank($event)"
      ></v-radio>
      <template v-if="!isMetaVerifySlip">
        <v-radio
          :label="$t('promptpay')"
          :value="{ value: 'promptpay', label: 'Promptpay' }"
          color="primary"
          @change="selectAllBank($event)"
        ></v-radio>
        <v-radio
          :label="$t('E-Wallet')"
          :value="{ value: 'eWallet', label: 'E-Wallet' }"
          color="primary"
          @change="selectAllBank($event)"
        ></v-radio>
        <v-radio
          :label="$t('Payment Gateway')"
          :value="{ value: 'paymentGateway', label: 'Payment Gateway' }"
          color="primary"
          @change="selectAllBank($event)"
        ></v-radio>
      </template>
    </v-radio-group>

    <v-layout v-if="bankVerifyData.typeAccount.value !== 'all'" wrap>
      <v-flex v-if="bankVerifyData.typeAccount.value === 'paymentGateway'" xs12 md6 class="pa-2">
        <span> {{ $t('Payment Gateway') }}</span>
        <div style="display: flex;">
          <v-avatar size="30" class="mr-2" style="align-self: center;">
            <img :src="bankName.image" />
          </v-avatar>
          <multiselect
            v-model="bankName"
            class="multi"
            :options="paymentGateway"
            label="name_th"
            select-label
            selected-label
            :allow-empty="false"
            :searchable="true"
            deselect-label
            track-by="value"
            @select="selectBank"
          >
            <template slot="option" slot-scope="props">
              <img style="width: 30px; vertical-align: middle;" :src="props.option.image" />
              <span class="ml-2">{{ props.option.name_th }}</span>
            </template>

            <span slot="noResult">
              {{ $t('item_not_found') }}
            </span></multiselect
          >
        </div>
      </v-flex>
      <v-flex v-else-if="bankVerifyData.typeAccount.value === 'eWallet'" xs12 md6 class="pa-2">
        <span> {{ $t('E-Wallet') }}</span>
        <div style="display: flex;">
          <v-avatar size="30" class="mr-2" style="align-self: center;">
            <img :src="bankName.image" />
          </v-avatar>
          <multiselect
            v-model="bankName"
            class="multi"
            :options="eWalletForVerify"
            label="name_th"
            select-label
            selected-label
            :allow-empty="false"
            :searchable="true"
            deselect-label
            track-by="value"
            @select="selectBank"
          >
            <template slot="option" slot-scope="props">
              <v-avatar size="25">
                <img :src="props.option.image" />
              </v-avatar>
              <span class="ml-2">{{ props.option.name_th }}</span>
            </template>
            <span slot="noResult">
              {{ $t('item_not_found') }}
            </span></multiselect
          >
        </div>
      </v-flex>
      <v-flex v-else-if="bankVerifyData.typeAccount.value === 'transfer'" xs12 md6 class="pa-2">
        <span> {{ $t('bank_name') }}</span>
        <div style="display: flex;">
          <v-avatar size="30" class="mr-2" style="align-self: center;">
            <img :src="bankName.image" />
          </v-avatar>
          <multiselect
            v-model="bankName"
            class="multi"
            :options="bankForVerify"
            label="name_th"
            select-label
            selected-label
            :allow-empty="false"
            :searchable="true"
            deselect-label
            track-by="value"
            @select="selectBank"
          >
            <template slot="option" slot-scope="props">
              <v-avatar size="25">
                <img :src="props.option.image" />
              </v-avatar>
              <span class="ml-2">{{ props.option.name_th }}</span>
            </template>
            <span slot="noResult">
              {{ $t('item_not_found') }}
            </span></multiselect
          >
        </div>
      </v-flex>
      <v-flex v-else-if="bankVerifyData.typeAccount.value === 'meta'" xs12 md6 class="pa-2">
        <div style="display: flex;">
          <v-avatar size="30" class="mr-2" style="align-self: center;">
            <img :src="bankName.image" />
          </v-avatar>
          <span class="ml-2">{{ bankName.name_th }}</span>
        </div>
      </v-flex>
      <v-flex
        xs12
        md6
        :class="[
          errors.has(`bankAccount_${bankVerifyData.id}`) ? 'has-error' : '',
          bankVerifyData.typeAccount.value === 'eWallet' ? 'pa-1' : 'pa-2'
        ]"
      >
        <span
          v-if="
            bankVerifyData.typeAccount &&
              (bankVerifyData.typeAccount.value === 'transfer' ||
                bankVerifyData.typeAccount.value === 'meta')
          "
        >
          {{ $t('bank_account_no') }}
        </span>

        <Intent-Prefill-Verify-Slip-Form-Example
          v-else-if="bankVerifyData.typeAccount && bankVerifyData.typeAccount.value === 'eWallet'"
          v-model="bankName.value"
        ></Intent-Prefill-Verify-Slip-Form-Example>

        <span
          v-else-if="
            bankVerifyData.typeAccount && bankVerifyData.typeAccount.value === 'paymentGateway'
          "
        >
          Biller ID
        </span>

        <span v-else> {{ $t('promptpay_no') }}</span>

        <span v-if="bankVerifyData.typeAccount && bankVerifyData.typeAccount.value === 'meta'">
          : xxxxxx{{ bankVerifyData.bankAccountNo }}
        </span>

        <template v-else>
          <input
            :key="bankVerifyData.id"
            v-model="bankVerifyData.bankAccountNo"
            v-validate="{ required: true, numeric: true, regex: /[0-9]{10,15}$/ }"
            :disabled="bankName && bankName.value === 'pg001'"
            type="text"
            class="form-control"
            :name="`bankAccount_${bankVerifyData.id}`"
            :data-vv-as="$t('data')"
            maxlength="15"
            @blur="removeSpecialCharacter(bankVerifyData.bankAccountNo)"
          />
          <span
            v-if="errors.has(`bankAccount_${bankVerifyData.id}`)"
            class="text-error"
            style="color:red"
          >
            {{ errors.first(`bankAccount_${bankVerifyData.id}`) }}
          </span>
        </template>
      </v-flex>
      <v-flex v-if="isMetaVerifySlip" xs12 md6 class="pa-2">
        <template>
          <span>
            {{ $t('receiver_name') }}
          </span>

          <input
            v-if="bankVerifyData.typeAccount.value === 'transfer'"
            :key="bankVerifyData.id"
            v-model="bankVerifyData.name"
            v-validate="{ required: true }"
            type="text"
            class="form-control"
            :name="`name_${bankVerifyData.id}`"
            :data-vv-as="$t('data')"
            maxlength="200"
          />
          <span v-else> : {{ bankVerifyData.name }} </span>
          <span v-if="errors.has(`name_${bankVerifyData.id}`)" class="text-error" style="color:red">
            {{ errors.first(`name_${bankVerifyData.id}`) }}
          </span>
        </template>
      </v-flex>

      <v-flex
        v-if="
          !isMetaVerifySlip &&
            bankVerifyData.typeAccount &&
            (bankVerifyData.typeAccount.value === 'transfer' ||
              bankVerifyData.typeAccount.value === 'promptpay')
        "
        xs12
        md6
      >
        <span style="margin-top: 10px"
          >{{ $t('receiver_name_keyword') }}
          <v-modal-help>
            <div slot="body">
              <v-card-text>
                <h3 class="mb-2">คำแนะนำ การเพิ่ม ชื่อผู้รับ (คีย์เวิร์ด) :</h3>
                <p class="mb-2">
                  ควรตั้งทั้งภาษาไทย และภาษาอังกฤษ เพื่อเพิ่มความแม่นยำในการตรวจสอบสลิปจาก
                  ชื่อผู้รับ (คีย์เวิร์ด)
                </p>
                <h4>ตัวอย่างการเพิ่ม ชื่อผู้รับ (คีย์เวิร์ด) :</h4>
                <template
                  v-if="
                    bankVerifyData.typeAccount && bankVerifyData.typeAccount.value === 'transfer'
                  "
                >
                  <ul class="tags" style="margin-bottom: 5px">
                    <li class="tag">
                      <span>โรโบ</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                    <li class="tag">
                      <span>โรโบลิงโก้</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                    <li class="tag">
                      <span>บริษัท โรโบลิงโก้</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                    <li class="tag">
                      <span>บริษัท โรโบลิงโก้ จำกัด</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                    <li class="tag">
                      <span>Robo</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                    <li class="tag">
                      <span>Robolingo</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                  </ul>
                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/verify_example/slip1.jpg"
                      class="pa-3"
                      width="300px"
                    />
                    <img
                      src="/static/img/assets/verify_example/slip2.jpg"
                      class="pa-3"
                      width="300px"
                    />
                  </div>
                </template>
                <template v-else>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li class="tag">
                      <span>พิชามญชุ์</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                    <li class="tag">
                      <span>บุญศิริ</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                    <li class="tag">
                      <span>Pichamon</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                    <li class="tag">
                      <span>Boonsiri</span>
                      <i class="mark fas fa-exclamation-circle"></i>
                    </li>
                  </ul>
                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/verify_example/slip.jpg"
                      class="pa-3"
                      width="300px"
                    />
                  </div>
                </template>
              </v-card-text>
            </div> </v-modal-help
        ></span>
        <div class="form-control" :class="{ 'has-error': errorMessage['keyword'] != '' }">
          <tags
            v-model="tag"
            style="margin-bottom: 5px;"
            :tags="bankVerifyData.keyword"
            :btn-text="$t('Add')"
            @tags-changed="
              newTags => {
                bankVerifyData.keyword = newTags
                updateQuestion()
              }
            "
            @before-adding-tag="checkTag('keyword', $event)"
          ></tags>
          <span v-show="errorMessage['keyword'] != ''" class="text-error">
            <template v-if="errorMessage['keyword'] == 'duplicate'">{{
              $t('Duplicate Question')
            }}</template>

            <template v-else-if="errorMessage['keyword'] == 'isOtherLanguage'">{{
              $t('supports_only_thai_and_english_languages')
            }}</template>
          </span>
        </div>
      </v-flex>
    </v-layout>
    <div class="mb-2">
      <small v-if="bankName && bankName.value === 'pg001'"
        >หมายเหตุ : การตรวจสลิปของ GB Prime Pay
        จะไม่สามารถตรวจสอบจากชื่อผู้รับโอน/ธนาคารที่รับโอนได้
        เนื่องจากระบบจะแสดงผลตามข้อมูลของแต่ละธนาคาร หากทางเพจต้องการตรวจสอบชื่อผู้รับโอน หรือ
        ธนาคารที่รับโอน กรุณาตรวจสอบจากระบบของ GB Prime
      </small>
    </div>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'
import Multiselect from 'vue-multiselect'
import IntentPrefillVerifySlipFormExample from './IntentPrefillVerifySlipFormExample'
export default {
  components: {
    Multiselect,
    IntentPrefillVerifySlipFormExample,
    Tags
  },
  inject: ['parentValidatorVerify'],
  props: ['value', 'index', 'data', 'isMetaVerifySlip'],
  data: function() {
    return {
      bankVerifyData: this.value,
      dataValue: this.data,
      bankForVerify: this.$store.state.bankForVerify,
      eWalletForVerify: this.$store.state.eWalletForVerify,
      paymentGateway: this.$store.state.paymentGateway,
      bankName: {},
      tag: '',
      errorMessage: {
        keyword: ''
      }
    }
  },
  created() {
    this.$validator = this.parentValidatorVerify
  },
  mounted() {
    const vm = this
    if (vm.bankForVerify.length > 0 && vm.eWalletForVerify.length > 0) {
      let bankAlltype = vm.bankForVerify.concat(vm.eWalletForVerify)
      bankAlltype = bankAlltype.concat(vm.paymentGateway)
      vm.bankName = bankAlltype.filter(bankInfo => bankInfo.value === vm.bankVerifyData.bankName)[0]
    }
  },
  methods: {
    checkTag(type, obj) {
      const vm = this
      vm.errorMessage[type] = ''
      if (obj.tag.isDuplicate) {
        vm.errorMessage[type] = 'duplicate'
        obj.error()
      } else if (obj.tag.isOtherLanguage) {
        vm.errorMessage[type] = 'isOtherLanguage'
        obj.error()
      } else obj.addTag()
    },
    updateQuestion: function() {
      const vm = this
      let keyword = []
      if (vm.bankVerifyData && vm.bankVerifyData.keyword && vm.bankVerifyData.keyword.length > 0) {
        vm.bankVerifyData.keyword.forEach(key => {
          if (key && key.text) {
            keyword.push(key.text.replace('เเ', 'แ').trim())
          }
        })
      }
    },
    selectAllBank(event) {
      const vm = this
      vm.bankVerifyData.bankAccountNo = ''
      switch (event.value) {
        case 'all':
          if (vm.dataValue.length > 0) {
            vm.dataValue = vm.dataValue.filter((item, index) => index === 0)
            vm.$emit('update:data', vm.dataValue)
          }
          break
        case 'transfer':
          vm.bankName = vm.bankForVerify[0]
          break
        case 'eWallet':
          vm.bankName = vm.eWalletForVerify[0]
          break
        case 'paymentGateway':
          vm.bankName = vm.paymentGateway[0]
          vm.bankVerifyData.bankAccountNo = '010556006812748'
          break
        case 'promptpay':
          vm.bankName = {}
      }
      vm.bankVerifyData.bankName = vm.bankName.value
      vm.$emit('input', vm.bankVerifyData)
    },
    selectBank(bankName) {
      const vm = this
      vm.bankVerifyData.bankName = bankName.value
      vm.bankVerifyData.bankAccountNo = ''
      if (bankName && bankName.value === 'pg001') {
        vm.bankVerifyData.bankAccountNo = '010556006812748'
      }
      vm.$emit('input', vm.bankVerifyData)
    },
    deleteDataBankVerify(value) {
      const vm = this
      vm.$emit('deleteDataBankVerify', value)
    },
    removeSpecialCharacter(value) {
      const vm = this
      const pattern = /-/g
      const new_text = value.replace(pattern, '')
      vm.bankVerifyData.bankAccountNo = new_text
    }
  }
}
</script>

<style lang="scss" scoped>
.form-control {
  max-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentPrefillVerifySlipForm.vue